// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat-page[data-v-24445918]{height:100vh}.chat-page[data-v-24445918],.main-wrapper[data-v-24445918]{display:flex;flex-direction:column}.main-wrapper[data-v-24445918]{flex-grow:1}.top-space-chat[data-v-24445918]{margin-top:20px}.chat-window[data-v-24445918]{display:flex;height:100%}.chat-right-container[data-v-24445918]{flex:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
